import { toast, Slide } from 'react-toastify'

const position = toast.POSITION.TOP_CENTER

export function notifyDefault(msg) {
  toast(`${msg}`, { position, transition: Slide })
}

export function notifySuccess(msg) {
  toast.success(`${msg}`, { position, transition: Slide })
}

export function notifyError(msg) {
  toast.error(`${msg}`, { position, transition: Slide })
}

export function notifyInfo(msg) {
  toast.info(`${msg}`, { position, transition: Slide })
}

export function notifyWarning(msg) {
  toast.warn(`${msg}`, { position, transition: Slide })
}
